import { ESortOrder } from '@type/index';

export const arraySort = [
  {
    key: '',
    value: {
      sort: '',
      order: '',
    },
    label: <span className="font-semibold text-gray-800">Tất cả</span>,
  },
  {
    key: 'maxPrice',
    value: {
      sort: 'price',
      order: ESortOrder?.Asc,
    },
    label: <span className="font-semibold text-gray-800">Giá thấp nhất</span>,
  },
  {
    key: 'minPrice',
    value: {
      sort: 'price',
      order: ESortOrder?.Desc,
    },
    label: <span className="font-semibold text-gray-800">Giá cao nhất</span>,
  },
  {
    key: 'new',
    value: {
      sort: 'createAt',
      order: ESortOrder?.Desc,
    },
    label: <span className="font-semibold text-gray-800">Mới nhất</span>,
  },
  {
    key: 'old',
    value: {
      sort: 'createAt',
      order: ESortOrder?.Asc,
    },
    label: <span className="font-semibold text-gray-800">Cũ nhất</span>,
  },
];

export const arrayDirection = [
  {
    key: '',
    label: <span className="font-semibold text-gray-800">Tất cả</span>,
  },
  {
    key: 'East',
    label: <span className="font-semibold text-gray-800">Đông</span>,
  },
  {
    key: 'West',
    label: <span className="font-semibold text-gray-800">Tây</span>,
  },
  {
    key: 'South',
    label: <span className="font-semibold text-gray-800">Nam</span>,
  },
  {
    key: 'North',
    label: <span className="font-semibold text-gray-800">Bắc</span>,
  },
  {
    key: 'SouthEast',
    label: <span className="font-semibold text-gray-800">Đông Nam</span>,
  },
  {
    key: 'SouthWest',
    label: <span className="font-semibold text-gray-800">Tây Nam</span>,
  },
  {
    key: 'NorthEast',
    label: <span className="font-semibold text-gray-800">Đông Bắc</span>,
  },
  {
    key: 'NorthWest',
    label: <span className="font-semibold text-gray-800">Tây Bắc</span>,
  },
];

export const arrayPrice = [
  {
    key: '',
    label: <span className="font-semibold text-gray-800">Tất cả</span>,
    value: {
      minPrice: null,
      maxPrice: null,
    },
  },
  {
    key: 'zeroToOne',
    label: <span className="font-semibold text-gray-800">Dưới 1 tỷ</span>,
    value: {
      minPrice: 0,
      maxPrice: Math.pow(10, 9),
    },
  },
  {
    key: 'oneToTwo',
    label: <span className="font-semibold text-gray-800">1 tỷ - 2 tỷ</span>,
    value: {
      minPrice: Math.pow(10, 9),
      maxPrice: 2 * Math.pow(10, 9),
    },
  },
  {
    key: 'twoToThree',
    label: <span className="font-semibold text-gray-800">2 tỷ - 3 tỷ</span>,
    value: {
      minPrice: 2 * Math.pow(10, 9),
      maxPrice: 3 * Math.pow(10, 9),
    },
  },
  {
    key: 'threeToFour',
    label: <span className="font-semibold text-gray-800">3 tỷ - 4 tỷ</span>,
    value: {
      minPrice: 3 * Math.pow(10, 9),
      maxPrice: 4 * Math.pow(10, 9),
    },
  },
  {
    key: 'fourToFire',
    label: <span className="font-semibold text-gray-800">Trên 4 tỷ</span>,
    value: {
      minPrice: 4 * Math.pow(10, 9),
      maxPrice: Math.pow(10, 12),
    },
  },
];

export const directions = [
  {
    key: 'East',
    label: 'Đông',
  },
  {
    key: 'West',
    label: 'Tây',
  },
  {
    key: 'South',
    label: 'Nam',
  },
  {
    key: 'North',
    label: 'Bắc',
  },
  {
    key: 'SouthEast',
    label: 'Đông Nam',
  },
  {
    key: 'SouthWest',
    label: 'Tây Nam',
  },
  {
    key: 'NorthEast',
    label: 'Đông Bắc',
  },
  {
    key: 'NorthWest',
    label: 'Tây Bắc',
  },
];
